import React, { useCallback, useEffect, useMemo, useRef, useState} from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import {
  useLocation,
  useNavigate,
  Link,
} from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import HeadPage from "./component/HeadPage";
import { PulseLoader } from "react-spinners";

/* ===========================
   SKELETON + KHUSUS TABLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% {
      background-position: -468px 0;
    }

    100% {
      background-position: 468px 0;
    }
  }

  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;

    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );

    background-size: 800px 104px;
  }

  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }

  .shimmer-row {
    height: 38px;
  }


  /* =========================================================
     TABLE PENILAIAN KEPALA SEKOLAH
     ========================================================= */

  .head-assessment-table-card {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
  }


  /*
    Scroll hanya ke bawah.
    Tidak ada scroll horizontal.
  */
  .head-assessment-table-scroll {
    position: relative;

    width: 100%;
    max-width: 100%;

    max-height: 570px;

    overflow-y: auto !important;
    overflow-x: hidden !important;

    -webkit-overflow-scrolling: touch;
  }


  .head-assessment-table {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;

    margin: 0 !important;

    border-collapse: separate !important;
    border-spacing: 0 !important;

    table-layout: fixed !important;
  }


  /* =========================
     HEADER
     ========================= */

  .head-assessment-table thead th {
    position: sticky !important;
    top: 0 !important;
    z-index: 15 !important;

    height: 54px;

    padding: 12px 14px !important;

    background: #f3f5ff !important;
    color: #25345f !important;

    font-size: 12.5px !important;
    font-weight: 700 !important;
    line-height: 1.45 !important;

    text-align: center !important;
    vertical-align: middle !important;

    white-space: normal !important;
    overflow-wrap: break-word;
    word-break: normal;

    border-right: 1px solid #e1e6ef !important;
    border-bottom: 1px solid #dbe2ee !important;

    background-clip: padding-box !important;
  }

  .head-assessment-table thead th:last-child {
    border-right: 0 !important;
  }


  /* =========================
     BODY
     ========================= */

  .head-assessment-table tbody td {
    min-height: 58px;

    padding: 12px 14px !important;

    background: #ffffff !important;
    color: #2b3654 !important;

    font-size: 13px !important;

    vertical-align: middle !important;

    border-right: 1px solid #e6ebf3 !important;
    border-bottom: 1px solid #edf0f5 !important;
  }

  .head-assessment-table tbody td:last-child {
    border-right: 0 !important;
  }

  .head-assessment-table tbody tr:last-child td {
    border-bottom: 0 !important;
  }

  .head-assessment-table tbody tr:hover td {
    background: #fafbff !important;
  }


  /* =========================
     TINGKATAN
     ========================= */

  .head-assessment-grade {
    text-align: center !important;
    vertical-align: middle !important;

    font-weight: 600 !important;
    line-height: 1.6 !important;

    white-space: normal !important;
    overflow-wrap: break-word;
  }


  /* =========================
     NAMA KEGIATAN
     ========================= */

  .head-assessment-activity {
    text-align: left !important;

    font-weight: 500 !important;
    line-height: 1.65 !important;

    white-space: normal !important;
    overflow-wrap: break-word;
  }


  /* =========================
     RATA-RATA GURU
     ========================= */

  .head-assessment-average {
    text-align: center !important;

    color: #2b3654 !important;

    font-weight: 700 !important;
  }


  /* =========================
     NILAI
     ========================= */

  .head-assessment-score {
    text-align: center !important;
  }

  .head-assessment-score-wrap {
    width: 60px;
    margin: 0 auto;
  }

  .head-assessment-table .ysb-score-input {
    width: 46px !important;
    height: 36px !important;

    margin: 0 auto;

    padding: 0 !important;

    border: 1px solid #dce4f2 !important;
    border-radius: 9px !important;

    outline: none !important;

    background: #ffffff !important;
    color: #27324f !important;

    font-size: 13px !important;
    font-weight: 700 !important;

    text-align: center !important;

    box-shadow: none !important;

    transition:
      border-color 0.15s ease,
      box-shadow 0.15s ease,
      background-color 0.15s ease;
  }

  .head-assessment-table .ysb-score-input:hover {
    border-color: #7892ff !important;
    background: #f8faff !important;
  }

  .head-assessment-table .ysb-score-input:focus {
    border-color: #7892ff !important;
    box-shadow: 0 0 0 3px rgba(63, 91, 234, 0.08) !important;
  }


  /* =========================
     SCROLLBAR
     ========================= */

  .head-assessment-table-scroll::-webkit-scrollbar {
    width: 7px;
  }

  .head-assessment-table-scroll::-webkit-scrollbar-track {
    background: #f4f6fb;
  }

  .head-assessment-table-scroll::-webkit-scrollbar-thumb {
    background: #bfc6d4;
    border-radius: 10px;
  }

  .head-assessment-table-scroll::-webkit-scrollbar-thumb:hover {
    background: #aeb7c7;
  }


  /* =========================
     RESPONSIVE
     ========================= */

  @media (max-width: 780px) {
    .head-assessment-table-scroll {
      max-height: 520px;
    }

    .head-assessment-table thead th,
    .head-assessment-table tbody td {
      padding: 10px 8px !important;
      font-size: 11.5px !important;
    }

    .head-assessment-score-wrap {
      width: 46px;
    }

    .head-assessment-table .ysb-score-input {
      width: 42px !important;
    }
  }

  @media (max-width: 480px) {
    .head-assessment-table thead th,
    .head-assessment-table tbody td {
      padding: 9px 5px !important;
      font-size: 10.5px !important;
    }

    .head-assessment-table .ysb-score-input {
      width: 38px !important;
      height: 34px !important;
    }
  }

  /* =========================================================
   MODE HANYA LIHAT
   Developer & Pengawas Adab
   ========================================================= */

.head-assessment-readonly-banner {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 11px;

  margin: 4px 0 14px;
  padding: 12px 14px;

  border: 1px solid #f0d79d;
  border-radius: 11px;

  background: #fffaf0;
  color: #7d5a16;

  font-size: 12.5px;
  line-height: 1.55;
}

.head-assessment-readonly-banner strong {
  display: block;
  margin-bottom: 2px;

  color: #6f4c0d;
  font-size: 12.5px;
  font-weight: 700;
}

.head-assessment-readonly-icon {
  display: inline-flex;

  width: 21px;
  height: 21px;
  flex: 0 0 21px;

  align-items: center;
  justify-content: center;

  margin-top: 1px;

  border-radius: 50%;

  background: #f0aa36;
  color: #ffffff;

  font-size: 12px;
  font-weight: 800;
}


/* INPUT DISABLED */

.head-assessment-table .ysb-score-input:disabled,
.head-assessment-table .ysb-score-input.ysb-input-disabled {
  cursor: not-allowed !important;

  border-color: #e0e5ee !important;

  background: #f2f4f7 !important;

  color: #9aa4b7 !important;

  box-shadow: none !important;

  opacity: 1 !important;
}

.head-assessment-table .ysb-score-input:disabled:hover,
.head-assessment-table .ysb-score-input.ysb-input-disabled:hover {
  border-color: #e0e5ee !important;
  background: #f2f4f7 !important;
}
`;


/* =========================================================
   HELPER SEKOLAH
   ========================================================= */

const sortSchools = (schools = []) => {
  const order = ["SD", "SMP", "SMA"];

  const getOrderIndex = (schoolName = "") => {
    const idx = order.findIndex((jenjang) =>
      String(schoolName)
        .toUpperCase()
        .includes(jenjang)
    );

    return idx === -1 ? 999 : idx;
  };

  return [...schools].sort((a, b) => {
    const jenjangA = getOrderIndex(a?.school_name);
    const jenjangB = getOrderIndex(b?.school_name);

    if (jenjangA !== jenjangB) {
      return jenjangA - jenjangB;
    }

    return String(a?.school_name || "").localeCompare(
      String(b?.school_name || "")
    );
  });
};


const removeBasementBekasi = ( schools = [], branchId) => {
  if (branchId === "BKS") {
    return schools.filter(
      (s) => s?.school_code !== "BASEMENT_BEKASI"
    );
  }

  return schools;
};


/* =========================================================
   HELPER NILAI
  ========================================================= */

const normalizeNilai = (value) => {
  if (
    value === "" ||
    value === null ||
    value === undefined
  ) {
    return null;
  }

  const numberValue = Number(value);

  return Number.isNaN(numberValue)
    ? null
    : numberValue;
};


const normalizeStatus = (value) => {
  if (
    value === "" ||
    value === null ||
    value === undefined
  ) {
    return null;
  }

  const numberValue = Number(value);

  return Number.isNaN(numberValue)
    ? null
    : numberValue;
};


const isNilaiEmpat = (value) =>
  normalizeNilai(value) === 4;


/* =========================================================
   HELPER TINGKATAN
   ========================================================= */

const getTingkatanNumber = (value) => {
  if (
    value === null ||
    value === undefined
  ) {
    return 999;
  }

  const text = String(value)
    .toUpperCase()
    .trim();

  const matchNumber = text.match(/\d+/);

  if (matchNumber) {
    return Number(matchNumber[0]);
  }

  const romanMap = {
    I: 1,
    II: 2,
    III: 3,
    IV: 4,
    V: 5,
    VI: 6,
    VII: 7,
    VIII: 8,
    IX: 9,
    X: 10,
    XI: 11,
    XII: 12,
  };

  return romanMap[text] || 999;
};


/* =========================================================
   AMBIL ROW ELEMENT
   ========================================================= */

const getElementRows = (element) => {
  if (Array.isArray(element?.detail)) {
    return element.detail
      .map((detailItem, detailIndex) => ({
        ...detailItem,

        __detailIndex: detailIndex,

        __tingkatanOrder: getTingkatanNumber(
          detailItem?.name_tingkatan ||
            detailItem?.grade_level_name ||
            detailItem?.tingkatan
        ),
      }))
      .sort((a, b) => {
        if (
          a.__tingkatanOrder !==
          b.__tingkatanOrder
        ) {
          return (
            a.__tingkatanOrder -
            b.__tingkatanOrder
          );
        }

        return String(
          a?.name_tingkatan || ""
        ).localeCompare(
          String(
            b?.name_tingkatan || ""
          ),
          undefined,
          {
            numeric: true,
          }
        );
      })
      .flatMap((detailItem) => {
        const rekapan = Array.isArray(
          detailItem?.rekapan
        )
          ? detailItem.rekapan
          : [];

        return rekapan.map(
          (row, rowIndex) => ({
            ...row,

            __rowIndex: rowIndex,

            __tingkatanOrder:
              detailItem.__tingkatanOrder,

            ysb_grade_level_id:
              row?.ysb_grade_level_id ||
              detailItem?.ysb_grade_level_id ||
              detailItem?.grade_level_id,

            name_tingkatan:
              row?.name_tingkatan ||
              detailItem?.name_tingkatan ||
              detailItem?.grade_level_name ||
              detailItem?.tingkatan ||
              "-",

            ysb_school_id:
              row?.ysb_school_id ||
              detailItem?.ysb_school_id,
          })
        );
      });
  }

  if (Array.isArray(element?.rekapan)) {
    return element.rekapan;
  }

  if (
    Array.isArray(element?.data_rekapan)
  ) {
    return element.data_rekapan;
  }

  if (
    Array.isArray(element?.data_sub_element)
  ) {
    return element.data_sub_element;
  }

  if (
    Array.isArray(element?.sub_elements)
  ) {
    return element.sub_elements;
  }

  return [];
};


/* =========================================================
   GROUP TINGKATAN UNTUK ROWSPAN
   ========================================================= */

const getGradeKey = (row, index) => {
  return (
    row?.ysb_grade_level_id ||
    row?.grade_level_id ||
    row?.ysb_grade_id ||
    row?.name_tingkatan ||
    row?.grade_level_name ||
    row?.tingkatan ||
    `tanpa-tingkatan-${index}`
  );
};


const buildRowsWithGradeSpan = (
  element
) => {
  const rows = getElementRows(element);

  const groups = new Map();

  rows.forEach((row, index) => {
    const key = getGradeKey(
      row,
      index
    );

    if (!groups.has(key)) {
      groups.set(key, {
        order: getTingkatanNumber(
          row?.name_tingkatan ||
            row?.grade_level_name ||
            row?.tingkatan ||
            row?.__tingkatanOrder
        ),

        rows: [],
      });
    }

    groups
      .get(key)
      .rows.push(row);
  });

  const sortedGroups =
    Array.from(
      groups.values()
    ).sort(
      (a, b) =>
        a.order - b.order
    );

  const result = [];

  sortedGroups.forEach((group) => {
    group.rows.forEach(
      (row, index) => {
        result.push({
          ...row,

          __showGrade:
            index === 0,

          __gradeRowSpan:
            group.rows.length,
        });
      }
    );
  });

  return result;
};


/* =========================================================
   HELPER UPDATE LOCAL
   ========================================================= */

const isSameRekapRow = (
  row,
  target,
  detail = null
) => {
  const rowSubElementId =
    row?.ysb_sub_element_id ||
    row?.id ||
    "";

  const targetSubElementId =
    target?.ysb_sub_element_id ||
    target?.id ||
    "";

  if (
    String(rowSubElementId) !==
    String(targetSubElementId)
  ) {
    return false;
  }

  const rowGradeLevelId =
    row?.ysb_grade_level_id ||
    row?.grade_level_id ||
    detail?.ysb_grade_level_id ||
    detail?.grade_level_id ||
    "";

  const targetGradeLevelId =
    target?.ysb_grade_level_id ||
    target?.grade_level_id ||
    target?.ysb_grade_id ||
    "";

  if (
    !rowGradeLevelId ||
    !targetGradeLevelId
  ) {
    return true;
  }

  return (
    String(rowGradeLevelId) ===
    String(targetGradeLevelId)
  );
};


const mapDataRekapRow = (
  data,
  elementId,
  target,
  updater
) => {
  if (!Array.isArray(data)) {
    return data;
  }

  return data.map(
    (dimensi) => ({
      ...dimensi,

      data_element: (dimensi?.data_element || []).map((element) => {
        if (
          element?.id !== elementId
        ) {
          return element;
        }

        if (
          Array.isArray(
            element?.detail
          )
        ) {
          return {
            ...element,

            detail:
              element.detail.map(
                (detail) => ({
                  ...detail,

                  rekapan: (
                    detail?.rekapan ||
                    []
                  ).map((row) => {
                    if (
                      !isSameRekapRow(
                        row,
                        target,
                        detail
                      )
                    ) {
                      return row;
                    }

                    return updater(
                      row,
                      detail
                    );
                  }),
                })
              ),
          };
        }

        const rowKeys = [
          "rekapan",
          "data_rekapan",
          "data_sub_element",
          "sub_elements",
        ];

        const nextElement = {
          ...element,
        };

        rowKeys.forEach(
          (key) => {
            if (
              !Array.isArray(
                element?.[key]
              )
            ) {
              return;
            }

            nextElement[key] =
              element[key].map(
                (row) => {
                  if (
                    !isSameRekapRow(
                      row,
                      target
                    )
                  ) {
                    return row;
                  }

                  return updater(
                    row,
                    null
                  );
                }
              );
          }
        );

        return nextElement;
      }),
    })
  );
};


/* =========================================================
   COMPONENT
   ========================================================= */

export default function NilaiKepsek() {
  document.title =
    "Penilaian Kepala Sekolah";


  /* =========================
     BASIC STATE
     ========================= */

  const [page] = useState(1);

  const [limit] = useState(1000);

  const [ascending] = useState(1);

  const [descending] = useState(0);

  const [keyword] = useState("");

  const token = localStorage.getItem("token");

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");

  const storageLevel = localStorage.getItem("level");

  // const ysbRoleName =
  //   localStorage.getItem(
  //     "ysb_role_name"
  //   );

  // const isPengawasAdab =
  //   ysbRoleName ===
  //   "Pengawas Adab";

  const ysbRoleName = localStorage.getItem("ysb_role_name");

  const normalizedRoleName =
    String(ysbRoleName || "")
      .trim()
      .toLowerCase();

  const normalizedLevel =
    String(storageLevel || "")
      .trim()
      .toLowerCase();

  const isPengawasAdab = 
    normalizedRoleName === "pengawas adab";

  const isDeveloper =
    normalizedLevel === "developer";

  const isNilaiReadOnlyRole = isDeveloper || isPengawasAdab;

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });

  const navigate = useNavigate();

  const location = useLocation();


  /* =========================
     LOADING
     ========================= */

  const [ loading, setLoading ] = useState(false);

  const [ loadingSchool, setLoadingSchool ] = useState(false);
  const [loadingDimensi, setLoadingDimensi] = useState(true);

  const [ isFetching, setIsFetching ] = useState(false);

  const [ isLockActionLoading, setIsLockActionLoading] = useState(false);


  /* =========================
     DATA STATE
    ========================= */

  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataDimensi, setGetDataDimensi ] = useState([]);
  const [getData, setGetData] = useState([]);


  /* =========================
     UI STATE
    ========================= */

  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);

  const id_user = localStorage.getItem("id_admin") || "";
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g,"");

  const nilaiBeforeEditRef =useRef({});

  const [namaTA, setNamaTA] = useState("");

  const [namaSmstr, setNamaSmstr] = useState("");


  /* =========================================================
     PERMISSION
     ========================================================= */

  const [ permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });


  const canUpdateNilai = useMemo(() => {
    /*
      Developer dan Pengawas Adab:
      VIEW ONLY
    */
    if (isNilaiReadOnlyRole) {
      return false;
    }

    /*
      Superadmin tetap boleh input.
    */
    if (normalizedLevel === "superadmin") {
      return true;
    }

    /*
      Role lain mengikuti permission.
    */
    return (
      permission?.update === 1 ||
      permission?.update === true
    );
  }, [
    permission?.update,
    isNilaiReadOnlyRole,
    normalizedLevel,
  ]);

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems =JSON.parse(localStorage.getItem("role_permission")) || [];

    if (level === "developer" ||level === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1,
      });
      return;
    }

    const found = storageItems.find((item) => item.menu?.url === location.pathname);

    if (!found) {
      navigate("/dashboard");
      return;
    }

    setPermission({
      create: found.create || 0,
      read: found.read || 0,
      update: found.update || 0,
      delete: found.delete || 0,
    });
  }, [
    location.pathname,
    navigate,
  ]);


  /* =========================================================
     FORM FILTER
     ========================================================= */
  const [ form2,setForm2 ] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
  });

  const isFormComplete =
    !!form2.ysb_semester_id &&
    !!form2.ysb_branch_id &&
    !!form2.ysb_school_id &&
    !!form2.ysb_dimensi_id;

  const isFilterComplete =
    isFilterDirty &&
    isFormComplete;


  /* =========================================================
     API HEADER
    ========================================================= */

  const fetchParams =
    useMemo(
      () => ({
        headers: {
          Authorization:
            `${token}`,

          "Content-Type":
            "application/json",
        },
      }),
      [token]
    );


  const isMounted = useRef(true);

  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current =
        false;

      abortControllers.current.forEach(
        (controller) =>
          controller.abort()
      );
    };
  }, []);


  /* =========================================================
     FETCH INIT
     ========================================================= */

  const fetchInit =
    useCallback(async () => {
      setLoading(true);

      const controller = new AbortController();

      abortControllers.current.push(
        controller
      );
      try {
        const [ branchRes, semesterRes] =
          await Promise.all([
            APIMS.get(
              `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
              {
                ...fetchParams,
                signal:
                  controller.signal,
              }
            ),

            APIMS.get(
              `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
              {
                ...fetchParams,
                signal:
                  controller.signal,
              }
            ),


          ]);

        if (!isMounted.current) {
          return;
        }

        /* BRANCH */
        if (branchRes?.status === 200) {
          const branches = branchRes.data.data || [];
          setGetDataBranch(branches);

          if ( branches.length > 0 ) {
            setForm2(
              (prev) => ({
                ...prev,

                ysb_branch_id:
                  prev.ysb_branch_id ||
                  branches[0]
                    .branch_code,
              })
            );
          }
        }

        /* SEMESTER */
        if (semesterRes?.status === 200) {
          const semesters = semesterRes.data.data || [];

          const active = semesters.find((semester) =>
                Number(semester?.status) === 1) ||semesters[0];

          setGetDataSemesterMap(semesters);

          if (active) {
            setNamaTA(active.name_year || "");

            setNamaSmstr(active.semester || "");

            setForm2(
              (prev) => ({
                ...prev,

                ysb_semester_id: prev.ysb_semester_id || active.id,
              })
            );
          }
        }

      } catch (err) {
        if (err?.name === "CanceledError" || err?.name === "AbortError") {
          return;
        }

        swal({
          title: "Failed",
          text: err?.response?.data?.message || err.message || "Error",
          icon: "error",
        });
      } finally {
        if (isMounted.current) {
          setLoading(false);
        }
      }
    }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);


  useEffect(() => { 
    fetchInit();
  }, [fetchInit]);


  /* =========================================================
     FETCH SCHOOL
    ========================================================= */
  const GetResponseDataSchool =
    useCallback(
      async (branchId) => {

        setLoadingSchool(true);
        setGetDataSchool([]);

        try {
          const res =
            await APIMS.get(
              `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
              fetchParams
            );

          if ( res?.status === 200 ) {
            let schools = res.data.data ||[];

            if (storageLevel === "developer" || storageLevel === "superadmin") {
              schools = schools.filter( (school) => school.ysb_branch_id === branchId);
            }

            schools = removeBasementBekasi( schools,  branchId);
            schools = sortSchools(schools);

            setGetDataSchool(schools);

            setForm2(
              (prev) => ({
                ...prev,
                ysb_school_id: schools.length > 0 ? schools[0].school_code : "",
              })
            );
          }
        } catch (err) {
          console.log(err);
        } finally {
          setLoadingSchool( false);
        }
      }, [ascending, fetchParams, limit, page, storageLevel]);


  useEffect(() => {
    if (form2.ysb_branch_id) {
      GetResponseDataSchool(form2.ysb_branch_id);
    }
  }, [form2.ysb_branch_id, GetResponseDataSchool]);


  /* =========================================================
     FETCH DIMENSI - mengikuti endpoint dan payload Penilaian
     HeadSuper tidak memiliki filter tingkatan; dikirim kosong.
    ========================================================= */
  const selectedSemester = useMemo(() =>
    getDataSemesterMap.find((semester) =>
      String(semester?.id) === String(form2.ysb_semester_id)
    ) || null,
    [getDataSemesterMap, form2.ysb_semester_id]
  );

  useEffect(() => {
    if (!form2.ysb_semester_id || !form2.ysb_branch_id || !form2.ysb_school_id) {
      setGetDataDimensi([]);
      setForm2((prev) => prev.ysb_dimensi_id ? { ...prev, ysb_dimensi_id: "" } : prev);
      return;
    }

    const controller = new AbortController();
    const fetchDimensi = async () => {
      setLoadingDimensi(true);
      setGetDataDimensi([]);
      setForm2((prev) => prev.ysb_dimensi_id ? { ...prev, ysb_dimensi_id: "" } : prev);
      try {
        const academicYearId =
          selectedSemester?.ysb_academic_year_id ??
          selectedSemester?.academic_year_id ??
          selectedSemester?.ysb_academic_year?.id ?? "";
        const response = await APILA.get("/api/dimensis", {
          ...fetchParams,
          signal: controller.signal,
          params: {
            page: 1,
            limit: 10,
            ascending: 1,
            search: "",
            branch: "",
            level: storageLevel || "",
            ysb_academic_year_id: academicYearId,
            ysb_semester_id: form2.ysb_semester_id,
            ysb_branch_id: form2.ysb_branch_id,
            ysb_school_id: form2.ysb_school_id,
            ysb_grade_level_id: "",
            ysb_teacher_id: "",
          },
        });
        if (controller.signal.aborted) return;
        const dims = (Array.isArray(response?.data?.data) ? response.data.data : [])
          .filter((dimensi) => dimensi?.status === undefined || Number(dimensi.status) === 1);
        setGetDataDimensi(dims);
        setForm2((prev) => ({ ...prev, ysb_dimensi_id: dims[0]?.id || "" }));
      } catch (error) {
        if (controller.signal.aborted) return;
        console.error("Gagal mengambil data dimensi:", error);
        setGetDataDimensi([]);
        setForm2((prev) => ({ ...prev, ysb_dimensi_id: "" }));
      } finally {
        if (!controller.signal.aborted) setLoadingDimensi(false);
      }
    };
    fetchDimensi();
    return () => controller.abort();
  }, [form2.ysb_semester_id, form2.ysb_branch_id, form2.ysb_school_id,
      selectedSemester, fetchParams, storageLevel]);

  /* =========================================================
     FETCH TABLE DATA
    ========================================================= */
  const GetResponseData =
    useCallback(async () => {
      if (!isFormComplete) {
        setGetData([]);

        setHasSearched(false);
        setIsFetching(false);
        return;
      }

      setIsFetching(true);
      
      try {
        const res = await APILA.get( "/api/recaps-head", {
          params: {
            ysb_semester_id: form2.ysb_semester_id,
            branch: form2.ysb_branch_id,
            ysb_dimensi_id: form2.ysb_dimensi_id,
            ysb_school_id: form2.ysb_school_id,
            level:storageLevel,
          },
          ...fetchParams,
        });

        if (res?.status === 200) {
          const result = res.data.data || [];
          const finalData = Array.isArray(result) ? result : [];

          setGetData(finalData);
          setHasSearched(true);
          setIsFilterDirty(false);

          const firstElement = finalData?.[0]?.data_element?.[0];

          if (firstElement?.name_element) {
            setSelectedTab(firstElement.name_element);
          } else {
            setSelectedTab(null);
          }
        }
      } catch (err) {
        setGetData([]);
        setHasSearched(false);

        swal({
          title: "Failed",
          text: err?.response?.data?.message || "Terjadi kesalahan",
          icon: "error",
        });
      } finally {
        setIsFetching(false);
      }
    }, [
      fetchParams,
      form2.ysb_semester_id,
      form2.ysb_branch_id,
      form2.ysb_dimensi_id,
      form2.ysb_school_id,
      isFormComplete,
      storageLevel,
    ]);


  /* =========================================================
     AUTO TAB
     ========================================================= */

  useEffect(() => {
    if (
      getData.length > 0 &&
      getData[0]
        ?.data_element
        ?.length > 0 &&
      !selectedTab
    ) {
      setSelectedTab(
        getData[0]
          .data_element[0]
          .name_element
      );
    }
  }, [
    getData,
    selectedTab,
  ]);


  /* =========================================================
     FIRST LOAD
     ========================================================= */

  useEffect(() => {
    if (
      !isFirstLoad ||
      !isFormComplete ||
      loadingSchool
    ) {
      return;
    }


    GetResponseData().finally(
      () => {
        setIsFirstLoad(
          false
        );
      }
    );
  }, [
    GetResponseData,
    isFirstLoad,
    isFormComplete,
    loadingSchool,
  ]);


  /* =========================================================
     RESET TAB
     ========================================================= */

  useEffect(() => {
    setSelectedTab(null);
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_dimensi_id,
  ]);


  /* =========================================================
     HANDLE FILTER
     ========================================================= */

  const handleChange = (e) => {
    const { name, value} = e.target;

    setForm2((prev) => ({
      ...prev,

      [name]: value,

      ...(name ===
      "ysb_branch_id"
        ? {
            ysb_school_id:
              "",
          }
        : {}),
    }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
      setGetData([]);
      setSelectedTab(null);
    }
  };


  /* =========================================================
     CARI
     ========================================================= */

  const handleCari =
    async () => {
      if ( !isFilterComplete || isFetching) {
        return;
      }

      setSelectedTab(null);
      setGetData([]);
      setHasSearched(false);
      await GetResponseData();
    };


  /* =========================================================
     NILAI
     ========================================================= */

  const getNilaiKey = (
    elementId,
    rekap
  ) => {
    return `${elementId}-${
      rekap?.ysb_grade_level_id ||
      "grade"
    }-${
      rekap?.ysb_sub_element_id ||
      rekap?.id ||
      "row"
    }`;
  };


  const updateRekapLocal =
    useCallback(
      (
        elementId,
        target,
        updater
      ) => {
        setGetData(
          (prev) =>
            mapDataRekapRow(
              prev,
              elementId,
              target,
              updater
            )
        );
      },
      []
    );


  const collectRows =
    useCallback(
      (filterFn) => {
        const rows = [];


        (getData || []).forEach(
          (dimensi) => {
            (
              dimensi?.data_element ||
              []
            ).forEach(
              (element) => {
                getElementRows(
                  element
                ).forEach(
                  (rekap) => {
                    if (
                      !filterFn ||
                      filterFn(
                        rekap,
                        element
                      )
                    ) {
                      rows.push({
                        elementId:
                          element?.id,

                        rekap,
                      });
                    }
                  }
                );
              }
            );
          }
        );


        return rows;
      },
      [getData]
    );


  const handleFocusNilai = (
    elementId,
    rekap
  ) => {
    const key =
      getNilaiKey(
        elementId,
        rekap
      );


    nilaiBeforeEditRef.current[
      key
    ] =
      rekap?.ysb_sub_element_value ??
      "";
  };


  const handleChangeNilaiLocal = (
    e,
    elementId,
    rekap
  ) => {
    const value =
      e.target.value;


    if (
      value !== "" &&
      !/^[1-4]$/.test(
        value
      )
    ) {
      return;
    }


    updateRekapLocal(
      elementId,
      rekap,
      (row) => ({
        ...row,

        ysb_sub_element_value:
          value === ""
            ? null
            : value,
      })
    );
  };


  /* =========================================================
     SAVE NILAI
     ========================================================= */

  const saveNilaiDB =
    async (
      rekap,
      elementId,
      value
    ) => {
      // if (
      //   isPengawasAdab ||
      //   !canUpdateNilai
      // ) {
      //   return;
      // }
      if (!canUpdateNilai) {
        return;
      }


      const recapId =
        rekap
          .ysb_element_recap_head_id;

      const payload = {
        ysb_sub_element_id: rekap.ysb_sub_element_id,
        ysb_sub_element_value: value,
        ysb_branch_id: form2.ysb_branch_id,
        ysb_school_id: form2.ysb_school_id,
        ysb_grade_level_id: rekap?.ysb_grade_level_id || "",
        ysb_dimensi_id: form2.ysb_dimensi_id,
        ysb_semester_id: form2.ysb_semester_id,
        ysb_element_id: elementId,
        user_id: output_id_user,
      };

      try {
        if (recapId === "default") {
          await APILA.put("/api/recaps-head/default",
            payload,
            fetchParams
          );
          ToastSuccess.fire({
            icon: "success",
            title: "Nilai berhasil disimpan",
          });
          return;
        }

        await APILA.put(`/api/recaps-head/${recapId}`,
          payload,
          fetchParams
        );

        ToastSuccess.fire({
          icon: "success",
          title: "Nilai berhasil diupdate",
        });
      } catch (err) {
        ToastError.fire({
          icon: "error",
          title: "Gagal menyimpan nilai",
        });

        throw err;
      }
    };


  /* =========================================================
     SAVE STATUS
     ========================================================= */

  const saveNilaiStatusDB = async (
      rekap,
      elementId,
      status
    ) => {
      // if (
      //   isPengawasAdab ||
      //   !canUpdateNilai
      // ) {
      //   return null;
      // }
      if (!canUpdateNilai) {
        return null;
      }

      const recapId = rekap?.ysb_element_recap_head_id;

      const payload = {
        ysb_sub_element_id: rekap?.ysb_sub_element_id,
        ysb_sub_element_value: normalizeNilai(rekap?.ysb_sub_element_value),
        ysb_sub_element_status:status,
        ysb_branch_id: form2.ysb_branch_id,
        ysb_school_id:form2.ysb_school_id,
        ysb_grade_level_id:rekap ?.ysb_grade_level_id || "",
        ysb_dimensi_id: form2.ysb_dimensi_id,
        ysb_semester_id: form2.ysb_semester_id,
        ysb_element_id: elementId,
        user_id: output_id_user,
      };

      if (!recapId || recapId === "default") {
        return APILA.put("/api/recaps-head/default",
          payload,
          fetchParams
        );
      }

      return APILA.put(`/api/recaps-head/${recapId}`,
        payload,
        fetchParams
      );
    };


  /* =========================================================
     BLUR NILAI
     ========================================================= */

  const handleBlurNilai = async (e, elementId, rekap) => {
      const raw = String(e.target.value || "").trim();
      const value = raw === "" ? null : Number(raw);
      const key = getNilaiKey(elementId,rekap);

      const before = nilaiBeforeEditRef.current[key] ?? "";

      if (String(before ?? "") === String(raw ?? "")) {
        return;
      }

      if (
        value !== null &&
        !/^[1-4]$/.test(
          raw
        )
      ) {
        return;
      }


      try {
        await saveNilaiDB(
          rekap,
          elementId,
          value
        );


        nilaiBeforeEditRef.current[
          key
        ] = raw;
      } catch (err) {
        updateRekapLocal(
          elementId,
          rekap,
          (row) => ({
            ...row,

            ysb_sub_element_value:
              before === ""
                ? null
                : before,
          })
        );
      }
    };


  /* =========================================================
     KUNCI NILAI
     Tetap dipertahankan dari file sebelumnya.
     Button tidak ditampilkan.
     ========================================================= */

  const validateLockAction =
    () => {
      if (
        !isFormComplete
      ) {
        swal({
          title: "Data belum lengkap",
          text: "Semester, Cabang, Sekolah, dan Dimensi wajib dipilih.",
          icon: "warning",
        });
        return false;
      }

      if (!hasSearched || getData.length === 0) {
        swal({
          title: "Data belum dimuat",
          text: "Klik Cari dulu sampai data penilaian tampil.",
          icon: "warning",
        });
        return false;
      }
      return true;
    };


  const handleKunciNilai =
    async () => {
      if (
        !validateLockAction() ||
        isLockActionLoading
      ) {
        return;
      }

      const rowsToLock =
        collectRows(
          (rekap) => {
            const status =
              normalizeStatus(
                rekap
                  ?.ysb_sub_element_status
              );


            return (
              isNilaiEmpat(
                rekap
                  ?.ysb_sub_element_value
              ) &&
              status !== 1
            );
          }
        );


      if (
        rowsToLock.length ===
        0
      ) {
        swal({
          title:
            "Tidak ada nilai 4 yang perlu dikunci",

          text:
            "Kunci nilai hanya memproses baris yang nilainya 4 dan belum terkunci.",

          icon: "info",
        });


        return;
      }


      const confirm =
        await swal({
          title: "Kunci Nilai?",
          text: `${rowsToLock.length} baris dengan nilai 4 akan dikunci. Nilai selain 4 tidak akan dikunci.`,
          icon: "warning",
          buttons: ["Batal", "Ya, Kunci",],
          dangerMode:false,
        });

      if (!confirm) {
        return;
      }

      setIsLockActionLoading(true);

      const previousData =
        JSON.parse(
          JSON.stringify(
            getData || []
          )
        );


      setGetData(
        (prev) =>
          rowsToLock.reduce(
            (
              current,
              item
            ) =>
              mapDataRekapRow(
                current,
                item.elementId,
                item.rekap,
                (row) => ({
                  ...row,

                  ysb_sub_element_status:
                    1,
                })
              ),
            prev
          )
      );


      try {
        await Promise.all(
          rowsToLock.map(
            ({
              elementId,
              rekap,
            }) =>
              saveNilaiStatusDB(
                rekap,
                elementId,
                1
              )
          )
        );

        ToastSuccess.fire({
          icon: "success",
          title:  "Nilai 4 berhasil dikunci",
        });

        await GetResponseData();
      } catch (err) {
        setGetData(
          previousData
        );

        ToastError.fire({
          icon: "error",
          title: err?.response ?.data?.message || "Gagal mengunci nilai",
        });
      } finally {
        setIsLockActionLoading(false);
      }
    };

  const handleCancelKunciNilai =
    async () => {
      if (
        !validateLockAction() ||
        isLockActionLoading
      ) {
        return;
      }

      const rowsToUnlock =
        collectRows(
          (rekap) => {
            const status =
              normalizeStatus(
                rekap
                  ?.ysb_sub_element_status
              );

            return (
              isNilaiEmpat(
                rekap
                  ?.ysb_sub_element_value
              ) &&
              status === 1
            );
          }
        );


      if (
        rowsToUnlock.length ===
        0
      ) {
        swal({
          title: "Tidak ada nilai 4 yang terkunci",
          text: "Cancel kunci hanya memproses nilai 4 yang statusnya terkunci.",
          icon: "info",
        });
        return;
      }


      const confirm =
        await swal({
          title: "Cancel Kunci Nilai?",
          text: `${rowsToUnlock.length} baris nilai 4 akan dibuka kuncinya.`,
          icon: "warning",
          buttons: ["Batal", "Ya, Cancel"],
          dangerMode: false,
        });

      if (!confirm) {
        return;
      }

      setIsLockActionLoading(true);

      const previousData =
        JSON.parse(
          JSON.stringify(
            getData || []
          )
        );

      setGetData(
        (prev) =>
          rowsToUnlock.reduce(
            (
              current,
              item
            ) =>
              mapDataRekapRow(
                current,
                item.elementId,
                item.rekap,
                (row) => ({
                  ...row,

                  ysb_sub_element_status:
                    0,
                })
              ),
            prev
          )
      );

      try {
        await Promise.all(
          rowsToUnlock.map(
            ({
              elementId,
              rekap,
            }) =>
              saveNilaiStatusDB(
                rekap,
                elementId,
                0
              )
          )
        );

        ToastSuccess.fire({
          icon: "success",
          title: "Kunci nilai 4 berhasil dibatalkan",
        });

        await GetResponseData();
      } catch (err) {
        setGetData(previousData);

        ToastError.fire({
          icon: "error",
          title: err?.response?.data?.message || "Gagal cancel kunci nilai",
        });
      } finally {
        setIsLockActionLoading(false);
      }
    };


  /* =========================================================
     RENDER
     ========================================================= */

  return (
    <>
      <style>
        {shimmerStyle}
      </style>

      <div className="body module-page assessment-page">
        <HeadPage />
        <div className="body-content module-content mt-2">
          {/* =================================================
              TAB PENILAIAN
              ================================================= */}

          <div className="assessment-mode-tabs">
            <div>
              <button className="btn assessment-mode-tab">
                <Link to="/element-recaps-dimensi">
                  Penilaian Guru
                </Link>
              </button>
            </div>

            <div className="ml-2">
              <button
                className="btn assessment-mode-tab active"
                style={{
                  backgroundColor: "#076db5ff",
                  color: "#fff",
                }}
              >
                Penilaian Kepala Sekolah
              </button>
            </div>
          </div>

          <hr className="assessment-mode-divider" />


          {/* =================================================
              FILTER MOBILE
              ================================================= */}

          {isTabletOrMobile ? (
            <div className="assessment-filter-card assessment-filter-mobile">

              {/* SEMESTER */}

              <Row
                style={{
                  marginTop: "10px",
                  padding: "0 12px",
                }}
              >
                <select
                  className="assessment-filter-select mr-2"
                  name="ysb_semester_id"
                  value={form2.ysb_semester_id}
                  onChange={handleChange}
                >
                  <option value="" hidden>
                    {namaTA ? `${namaTA} (Semester ${namaSmstr})` : "Pilih Semester"}
                  </option>

                  {getDataSemesterMap.map(
                    (semester,index) => (
                      <option key={semester?.id || index}
                        value={semester?.id}
                      >
                        {semester?.name_year}{" "}(Semester{" "}{semester?.semester})
                        {Number(semester?.status) === 1 ? " • Aktif" : ""}
                      </option>
                    )
                  )}
                </select>
              </Row>

              {/* CABANG */}

              <Row
                style={{
                  marginTop: "10px",
                  padding:"0 12px",
                }}
              >
                <select
                  className="assessment-filter-select mr-2"
                  name="ysb_branch_id"
                  value={form2.ysb_branch_id}
                  onChange={handleChange}
                >
                  <option value="" hidden>
                    Pilih Cabang
                  </option>

                  {getDataBranch.map(
                    (branch, index) => (
                      <option
                        key={branch?.branch_code || index}
                        value={branch?.branch_code}
                      >
                        {branch?.branch_name}
                      </option>
                    )
                  )}
                </select>
              </Row>

              {/* SEKOLAH */}
              <Row
                style={{
                  marginTop:"10px",
                  padding: "0 12px",
                }}
              >
                <select
                  className="assessment-filter-select mr-2"
                  name="ysb_school_id"
                  value={form2.ysb_school_id}
                  onChange={handleChange}
                  disabled={loadingSchool}
                >
                  <option value="" hidden>
                    {loadingSchool
                      ? "Memuat data sekolah..."
                      : "Pilih Sekolah"}
                  </option>

                  {!loadingSchool &&
                    getDataSchool.map((school,index) => (
                      <option
                        key={school?.school_code ||index}
                        value={school?.school_code}
                      >
                        {school?.school_name}
                      </option>
                    )
                  )}
                </select>
              </Row>


              {/* DIMENSI */}
              <Row
                style={{
                  marginTop:"10px",
                  padding: "0 12px",
                }}
              >
                <select
                  className="assessment-filter-select mr-2"
                  name="ysb_dimensi_id"
                  value={form2.ysb_dimensi_id}
                  onChange={handleChange}
                  disabled={loadingDimensi}
                  style={{ backgroundColor: loadingDimensi ? "#f5f5f5" : "#fff", cursor: loadingDimensi ? "not-allowed" : "pointer" }}
                >
                  {loadingDimensi ? (
                    <option value="">Memuat dimensi...</option>
                  ) : getDataDimensi.length === 0 ? (
                    <option value="">Belum ada dimensi</option>
                  ) : (
                    <>
                      <option value="" hidden>Pilih Dimensi</option>
                      {getDataDimensi.map((dimensi, index) => (
                        <option key={dimensi?.id || index} value={dimensi?.id}>
                          {dimensi?.name_dimensi}
                        </option>
                      ))}
                    </>
                  )}
                </select>
              </Row>


              {/* CARI */}
              <Row
                style={{
                  marginTop: "12px",
                  padding: "0 12px",
                }}
              >
                <button
                  onClick= {handleCari}
                  disabled= {!isFilterComplete || isFetching}
                  className= "btn assessment-filter-button"
                >
                  {isFetching ? "Memuat..." : "Cari"}
                </button>
              </Row>
            </div>
          ) : (

            /* =================================================
               FILTER DESKTOP
               ================================================= */

            <div className="assessment-filter-card mb-3">
              {loading ? (
                <>
                  <div className="mb-3 d-flex">
                    <div
                      className="shimmer shimmer-select mr-3"
                      style={{
                        width: 180,
                        borderRadius:"12px",
                      }}
                    />

                    <div
                      className="shimmer shimmer-select mr-3"
                      style={{
                        width: 220,
                        borderRadius: "12px",
                      }}
                    />

                    <div
                      className="shimmer shimmer-select mr-3"
                      style={{
                        width: 220,
                        borderRadius: "12px",
                      }}
                    />
                  </div>

                  <div className="assessment-filter-row d-flex">
                    <div
                      className="shimmer shimmer-select mr-2"
                      style={{
                        width: 220,
                        borderRadius: "12px",
                      }}
                    />

                    <div
                      className="shimmer shimmer-select mr-2"
                      style={{
                        width: 70,
                        borderRadius: "12px",
                      }}
                    />
                  </div>
                </>
              ) : (
                <div className="mb-3 ">
                  <div className="assessment-filter-row">

                    {/* SEMESTER */}
                    <div>
                      <label className="leger-filter-label">Semester</label>
                      <select
                        className="assessment-filter-select mr-2"
                        name="ysb_semester_id"
                        value={form2.ysb_semester_id}
                        onChange={handleChange}
                      >
                        <option value=""hidden>
                          {namaTA
                            ? `${namaTA} (Semester ${namaSmstr})`
                            : "Pilih Semester"}
                        </option>

                        {getDataSemesterMap.map(
                          (semester,index) => (
                            <option
                              key= {semester?.id || index}
                              value= {semester?.id}
                            >
                              {semester?.name_year}{" "}
                              (Semester{" "}
                              {
                                semester?.semester
                              })
                              {Number(
                                semester?.status
                              ) ===
                              1
                                ? " • Aktif"
                                : ""}
                            </option>
                          )
                        )}
                      </select>
                    </div>

                    {/* CABANG */}
                    <div>
                      <label className="leger-filter-label">Cabang</label>
                      <select
                        className="assessment-filter-select mr-2"
                        name="ysb_branch_id"
                        value={form2.ysb_branch_id}
                        onChange={handleChange}
                      >
                        <option value="" hidden>
                          Pilih Cabang
                        </option>

                        {getDataBranch.map(
                          (branch,index) => (
                            <option
                              key={branch?.branch_code || index}
                              value={branch?.branch_code}
                            >
                              {branch?.branch_name}
                            </option>
                          )
                        )}
                      </select>
                    </div>

                    {/* SEKOLAH */}
                    <div>
                      <label className="leger-filter-label">Sekolah</label>
                      <select
                        className="assessment-filter-select mr-2"
                        name="ysb_school_id"
                        value={form2.ysb_school_id}
                        onChange={handleChange}
                        disabled={loadingSchool}
                      >
                        <option value=""hidden>
                          {loadingSchool
                            ? "Memuat data sekolah..."
                            : "Pilih Sekolah"}
                        </option>

                        {!loadingSchool && 
                          getDataSchool.map((school,index) => (
                            <option
                              key={school?.school_code ||index}
                              value={school?.school_code}
                            >
                              {school?.school_name}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                  </div>

                  {/* Baris 2 */}
                  <div className="assessment-filter-row mt-3 d-flex">
                    <div>
                      <label className="leger-filter-label">Dimensi</label>
                      <select
                        className="assessment-filter-select mr-2"
                        name="ysb_dimensi_id"
                        value={form2.ysb_dimensi_id}
                        onChange={handleChange}
                        disabled={loadingDimensi}
                        style={{ backgroundColor: loadingDimensi ? "#f5f5f5" : "#fff", cursor: loadingDimensi ? "not-allowed" : "pointer" }}
                      >
                        {loadingDimensi ? (
                          <option value="">Memuat dimensi...</option>
                        ) : getDataDimensi.length === 0 ? (
                          <option value="">Belum ada dimensi</option>
                        ) : (
                          <>
                            <option value="" hidden>Pilih Dimensi</option>
                            {getDataDimensi.map((dimensi, index) => (
                              <option key={dimensi?.id || index} value={dimensi?.id}>
                                {dimensi?.name_dimensi}
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                    </div>

                    {/* CARI */}
                    <div className="mt-4">
                      <button
                        onClick={handleCari}
                        disabled={!isFilterComplete || isFetching}
                        className="btn assessment-filter-button"
                      >
                        {isFetching
                          ? "Memuat..."
                          : "Cari 1"}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}


          {/* =================================================
              LOADER
          ================================================= */}
          {isFetching && (
            <div className="text-center" style={{padding: "10px 0"}}>
              <PulseLoader color="#3f5bea" size={12}/>
            </div>
          )}


          {/* =================================================
              DATA KOSONG
              ================================================= */}

          {hasSearched && !isFetching && getData.length === 0 && (
            <div className="module-table-card">
              <div className="module-empty-state-content">
                Data penilaian belum tersedia untuk filter yang dipilih.
              </div>
            </div>
          )}

          {/* =================================================
              TAB + TABLE
              ================================================= */}

          {hasSearched && !isFetching && getData.length > 0 && (
            <>
              {/* MODE HANYA LIHAT */}
              {isNilaiReadOnlyRole && (
                <div className="head-assessment-readonly-banner">
                  <span className="head-assessment-readonly-icon">
                    i
                  </span>
                  <div>
                    <strong>Mode Hanya Lihat</strong>
                    <div>
                      {isPengawasAdab
                        ? "Role Pengawas Adab tidak dapat menginput atau mengubah nilai. Data penilaian hanya dapat dilihat."
                        : "Role Developer tidak dapat menginput atau mengubah nilai. Data penilaian hanya dapat dilihat."}
                    </div>
                  </div>
                </div>
              )}

              <Tabs
                id="head-assessment-tabs"
                activeKey={selectedTab}
                onSelect={(key) =>
                  setSelectedTab(key)
                }
                className="assessment-tabs mb-3 mt-4 nav-tabs"
              >
                {(getData?.[0]?.data_element || []).map(
                  (element, eIdx) => (
                    <Tab
                      key={element?.id || eIdx}
                      eventKey={element?.name_element}
                      title={element?.name_element}
                      className="nav-item"
                    >
                      {/* Indikator */}
                      <div className="assessment-element-info">
                        <h5 className="mt-2 mb-2">
                          {element?.description}
                        </h5>
                      </div>

                      {/* TABLE */}
                      <Col
                        xl="12"
                        sm="12"
                        className="module-column"
                      >
                        <div className="mt-3">
                          <div className="module-table-card assessment-table-card head-assessment-table-card">
                            {/* <div className="module-table-scroll head-assessment-table-scroll"> */}
                            <div>
                              <table
                                className="module-table head-assessment-table"
                                id="basic-datatable"
                              >
                                {/* PROPORSI KOLOM */}
                                <colgroup>
                                  <col
                                    style={{
                                      width: "15%",
                                    }}
                                  />

                                  <col
                                    style={{
                                      width: "45%",
                                    }}
                                  />

                                  <col
                                    style={{
                                      width: "25%",
                                    }}
                                  />

                                  <col
                                    style={{
                                      width: "15%",
                                    }}
                                  />
                                </colgroup>


                                {/* HEADER */}

                                <thead>
                                  <tr>
                                    <th>Tingkatan</th>
                                    <th>Nama Kegiatan</th>
                                    <th>Rata-Rata Penilaian Guru</th>
                                    <th>Nilai</th>
                                  </tr>
                                </thead>

                                {/* BODY */}

                                <tbody>
                                  {buildRowsWithGradeSpan(element).map(
                                    (rekap,idx) => (
                                      <tr
                                        className="ysb-row-hover"
                                        key={`${
                                          rekap?.ysb_grade_level_id ||
                                          "grade"
                                        }-${
                                          rekap?.ysb_sub_element_id ||
                                          "sub"
                                        }-${idx}`}
                                      >
                                        {/* TINGKATAN */}
                                        {rekap.__showGrade && (
                                          <td
                                            rowSpan={
                                              rekap.__gradeRowSpan
                                            }
                                            className="head-assessment-grade"
                                          >
                                            {rekap?.name_tingkatan ||
                                              rekap?.grade_level_name ||
                                              rekap?.tingkatan ||
                                              "-"}
                                          </td>
                                        )}

                                        {/* NAMA INDIKATOR */}
                                        <td className="head-assessment-activity">
                                          {rekap?.ysb_sub_element_name ||
                                            rekap?.description ||
                                            "-"}
                                        </td>

                                        {/* RATA-RATA GURU */}
                                        <td className="head-assessment-average">
                                          {rekap?.ysb_sub_element_value_teacher_average ??
                                            "-"}
                                        </td>

                                        {/* NILAI */}
                                        <td className="head-assessment-score">
                                          <div className="head-assessment-score-wrap">
                                          
                                            <input
                                              type="text"
                                              inputMode="numeric"
                                              maxLength={1}

                                              className={`ysb-score-input form-control text-center ${
                                                !canUpdateNilai
                                                  ? "ysb-input-disabled"
                                                  : ""
                                              }`}

                                              value={
                                                rekap?.ysb_sub_element_value ??
                                                ""
                                              }

                                              /*
                                                Developer & Pengawas Adab tidak bisa input.
                                              */
                                              disabled={!canUpdateNilai}

                                              title={
                                                isPengawasAdab
                                                  ? "Pengawas Adab hanya dapat melihat nilai"
                                                  : isDeveloper
                                                  ? "Developer hanya dapat melihat nilai"
                                                  : !canUpdateNilai
                                                  ? "Anda tidak memiliki akses untuk mengubah nilai"
                                                  : "Input nilai 1 - 4"
                                              }

                                              onFocus={() => {
                                                if (!canUpdateNilai) return;

                                                handleFocusNilai(
                                                  element.id,
                                                  rekap
                                                );
                                              }}

                                              onChange={(e) => {
                                                if (!canUpdateNilai) return;

                                                handleChangeNilaiLocal(
                                                  e,
                                                  element.id,
                                                  rekap
                                                );
                                              }}

                                              onBlur={(e) => {
                                                if (!canUpdateNilai) return;

                                                handleBlurNilai(
                                                  e,
                                                  element.id,
                                                  rekap
                                                );
                                              }}

                                              onKeyDown={(e) => {
                                                if (!canUpdateNilai) {
                                                  e.preventDefault();
                                                  return;
                                                }

                                                if (
                                                  [
                                                    ".",
                                                    ",",
                                                    "e",
                                                    "E",
                                                    "+",
                                                    "-",
                                                  ].includes(e.key)
                                                ) {
                                                  e.preventDefault();
                                                }
                                              }}
                                            />

                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Tab>
                  )
                )}
              </Tabs>

                </>
              
            )}
        </div>
      </div>
    </>
  );
}